let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c0bhz")).then(() => parcelRequire('chRFA'));